import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const LinkedIn = ({ size, color, x = '0px', y = '0px', scale = 0 }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '40px'}
      height={size || '40px'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 40 40"
      fill={color || 'currentColor'}
    >
      <path
        d="M21.705,34.537h-6.82V14.078h6.82v3.41c1.454-1.849,3.658-2.952,6.01-3.006
        c4.229,0.023,7.642,3.465,7.629,7.694v12.361h-6.82V23.029c-0.273-1.905-1.906-3.318-3.831-3.314
        c-0.842,0.027-1.636,0.395-2.2,1.021c-0.564,0.625-0.849,1.454-0.788,2.294V34.537z M11.475,34.537h-6.82V14.078h6.82V34.537z
        M8.066,10.669c-1.883,0-3.41-1.527-3.41-3.41s1.527-3.41,3.41-3.41s3.41,1.527,3.41,3.41c0,0.904-0.359,1.772-0.999,2.411
        C9.837,10.309,8.97,10.669,8.066,10.669z"
        fill={color || 'currentColor'}
      />
    </StyledSvg>
  );
};
